import {
  MigrateUserRequestProto_Body,
  RecordRecentlyRetriagedAttemptRequestProto_Body,
} from "@noom/noom-contracts/noom_contracts/backend/retriage/retriage_service";
import { Api } from "@noom/noomscape";

import { captureException } from "@/utils/sentry";

import axios from "axios";

// This is passed as an environment variable at build time,
// or when running locally from the .env file at the root of the project
const ANONYMOUS_CLIENT_TOKEN = process.env.HIVE_ANONYMOUS_CLIENT_TOKEN;

Api.register(
  "retriage.migrateUser",
  async (request: MigrateUserRequestProto_Body) => {
    await axios({
      url: "/retriage/migrateUser",
      urlWithPathParams: "/retriage/migrateUser",
      baseURL: window.ENV.SERVER_URL,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: request,
    });
  },
);

Api.register(
  "retriage.recordRecentlyRetriagedAttempt",
  async (request: RecordRecentlyRetriagedAttemptRequestProto_Body) => {
    if (!ANONYMOUS_CLIENT_TOKEN) {
      const error = new Error("ANONYMOUS_CLIENT_TOKEN is not set");
      if (process.env.NODE_ENV === "development") {
        // eslint-disable-next-line no-console
        console.error(error);
      } else {
        captureException(error);
      }
      throw error;
    }

    await axios({
      url: "/retriage/recordRecentlyRetriagedAttempt",
      urlWithPathParams: "/retriage/recordRecentlyRetriagedAttempt",
      baseURL: window.ENV.SERVER_URL,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ANONYMOUS_CLIENT_TOKEN}`,
      },
      data: request,
    });
  },
);
